







import { Filter } from "@/utils/decorator";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class CustomNumberLabel extends Vue {
  @Prop({ default: "" }) title?: string;
  @Prop({ default: "" }) value?: string;

  @Filter()
  numberFormat(value: string) {
    if (value == null) {
      return "-";
    }
    const regexp = /\B(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(regexp, ",");
  }
}
